import {axios_tenant} from "../../../../axios";

const instance = axios_tenant;

export const get = async (url, api_config,data_only = true) => {
    const response = await instance.get(url, addTokenToConfig(api_config));
    return data_only ? response?.data : response;
};

export const post = async (url, data, api_config, data_only = true) => {
    const response = await instance.post(url, data, addTokenToConfig(api_config));
    return data_only ? response?.data : response;
};

export const put = async (url, data, api_config) => {
    const response = await instance.put(url, data, addTokenToConfig(api_config));
    return response?.data;

};

export const patch = async (url, data, api_config, data_only = true) => {
    const response = await instance.patch(url, data, addTokenToConfig(api_config));
    return data_only ? response?.data : response;
};

export const del = async (url, data, api_config, data_only = true) => {
    const response = await instance.delete(url, addTokenToConfig(api_config, data));
    return data_only ? response?.data : response;
};

//adding token in the config
const addTokenToConfig = (api_config, data) => {
    const token = localStorage.getItem("TREXO_TENANT_AUTH_TOKEN"); // Replace with your actual token
    const sessionId = sessionStorage.getItem("sessionId");

    if (!api_config) {
        api_config = {};
    }

    if (!api_config.headers) {
        api_config.headers = {};
    }

    if (data) {
        api_config.data = data;
    }

    // Add the token to the request headers
    if (sessionId && token) {
        api_config.headers.Authorization = `Bearer ${token} ${sessionId}`;
    }

    //default language
    api_config.headers["Accept-Language"] = "en";

    return api_config;
};